import { AxiosResponse } from "axios";

export function hasError(response: AxiosResponse) {
  return response?.data?.hasError ?? true;
}

export function getData(response: AxiosResponse) {
  return response?.data?.data ?? null;
}
